import { render, staticRenderFns } from "./ManufacturerPriceUpload.vue?vue&type=template&id=2de9f6e4&"
import script from "./ManufacturerPriceUpload.vue?vue&type=script&lang=js&"
export * from "./ManufacturerPriceUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports